import { useQuery } from '@tanstack/react-query';
import HttpClient from '@/api/HttpClient';

const httpClient = new HttpClient();

interface GpsHistoryParams {
  userId: number;
  startDate: string;
  endDate: string;
  skip?: number;
  take?: number;
}

interface GpsTrack {
  id: number;
  userId: number;
  clockSessionId: number;
  latitude: string;
  longitude: string;
  accuracy: string;
  timestamp: string;
  createdAt: string;
  updatedAt: string;
}

interface GpsHistoryResponse {
  success: boolean;
  list: GpsTrack[];
  count: number;
}

const fetchGpsHistory = async (params: GpsHistoryParams): Promise<GpsHistoryResponse> => {
  const { userId, ...queryParams } = params;
  const response = await httpClient.get<GpsHistoryResponse>(
    `api/gps-tracking/admin/history/${userId}`,
    queryParams
  );
  return response.data;
};

export const useAdminGpsHistory = (
  userId: number | undefined,
  startDate: string,
  endDate: string,
  skip: number = 0,
  take: number = 1000
) => {
  return useQuery({
    queryKey: ['admin-gps-history', userId, startDate, endDate, skip, take],
    queryFn: () => fetchGpsHistory({ userId: userId!, startDate, endDate, skip, take }),
    enabled: !!userId && !!startDate && !!endDate,
    staleTime: 2 * 60 * 1000, // 2 minutes
    gcTime: 5 * 60 * 1000, // 5 minutes
  });
};
